import { useEffect } from 'react'

import { pinterestPixelService } from '~/shared/services/pinterestPixelService'

const PINTEREST_TAG_ID = '2613241822082'

export const usePinterestPixelInitialization = () => {
  useEffect(() => {
    if (window.pintrk) return

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true

    script.text = `
      !function(e) {
        if(!window.pintrk) {
          window.pintrk=function() {
            window.pintrk.queue.push(Array.prototype.slice.call(arguments))
          };
          var n=window.pintrk;n.queue=[],n.version="3.0";
          var t=document.createElement("script");t.async=!0,t.src=e;
          var r=document.getElementsByTagName("script")[0];
              r.parentNode.insertBefore(t,r)
        }
      }
      ("https://s.pinimg.com/ct/core.js");
      `

    document.head.appendChild(script)

    pinterestPixelService.load(PINTEREST_TAG_ID)
    pinterestPixelService.trackPage()
  }, [])
}
